import { gql } from "@apollo/client";
import { gaSetSharedEventParams } from "helpers/gtag";
import useData from "helpers/useData";
import React from "react";
import NotFoundPage from "shared/NotFoundPage";
import PageTitle from "shared/PageTitle";

import HighlightPlayer, { HighlightPlayerFragment } from "./video_player/HighlightPlayer";

export default function EventPage({ eventId }) {
  const [data] = useData(
    gql`
      query EventPage($eventId: ID!) {
        event(id: $eventId) {
          id
          title
          org {
            gaId
          }
          ...HighlightPlayerFragment
        }
      }
      ${HighlightPlayerFragment}
    `,
    {
      eventId,
    },
  );
  if (data && !data.event) return <NotFoundPage />;
  gaSetSharedEventParams({ org_id: data?.event?.org?.gaId });

  return (
    <>
      <PageTitle title="Highlight" />
      <HighlightPlayer event={data?.event} eventId={eventId} />
    </>
  );
}
